// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
// więcej komponentów: https://www.stimulus-components.com/

import { application } from "./application"

import ScrollController from "./scroll_controller"
import ChartSprintController from "./chart_sprint_controller"
import PieChartSprintController from "./pie_chart_sprint_controller"
import HelloController from "./hello_controller"
import DropdownController from "./dropdown_controller"
import ToggleController from "./toggle_controller"
import ColumnsReorderController from "./columns_reorder_controller"
import DropdownPhotoController from "./dropdown_photo_controller"
import SelectController from "./select_controller"
import EmailController from "./email_controller"
import JoditController from "./jodit_controller"

import MarkdownEditorController from "./markdown_editor_controller"
import ModalController from "./modal_controller"
import UserSettingFieldsController from "./user_setting_fields_controller.js"
import SidebarController from "./sidebar_controller"
import AttachmentViewController from "./attachment_view_controller"
import ModalViewController from "./modal_view_controller"
import FormAttachmentController from "./form_attachment_controller"
import EntryViewController from "./entry_view_controller"
import HeaderController from "./header_controller"
import DropdownSearchController from "./dropdown_search_controller"
import MultiselectController from "./multiselect_controller"
import MultiselectSearchController from "./multiselect_search_controller"
import MarkdownPreviewController from "./markdown_preview_controller"
import CrmViewController from "./crm_view_controller"
import NotificationController from "./notification_controller"
import HelplinkController from "./helplink_controller"
import AfterChangeUpdateController from "./after_change_update_controller.js"
import IntumDropzoneController from "./intum_dropzone_controller"
import CopyValueController from "./copy_value_controller"
import BulkOptionsController from "./bulk_options_controller"
import BulkOptionsAdvancedController from "./bulk_options_advanced_controller"
import CommentsController from "./comments_controller"
import CardsController from "./cards_controller"
import ReloadController from "./reload_controller"
import PriorityController from "./priority_controller"
import CalendarController from "./calendar_controller"
import TagPickerController from "./tag_picker_controller"
import FormsController from "./forms_controller"
import ClientModalController from "./client_modal_controller"
import CountryPrefixController from "./country_prefix_controller"
import EmployeeLeaveController from "./employee_leave_controller"
import DealTaxController from "./deal_tax_controller"
import ColorPickerSimpleController from "./color_picker_simple"
import DropdownChangeMultiselectFillController from "./dropdown_change_multiselect_fill_controller"
import DragDropConttroller from "./drag_drop_controller"
import KanbanDragController from "./kanban_drag_controller"
import DraftController from "./draft_controller"
import CommonFormController from "./common_form_controller"
import AnimatedDropdownController from "./animated_dropdown_controller"
import AccountPrefixController from "./account_prefix_controller"
import RolePrivilegesController from "./role_privileges_controller"
import CopyToClipboardController from "./copy_to_clipboard_controller"
import MultiDropdownController from "./multi_dropdown_controller"
import ImageModalController from "./image_modal_controller"
import IntumSelectController from "./intum_select_controller"
import GreedyDropdownController from "./greedy_dropdown_controller.js"
import SelectLoadController from "./select_load_controller"
import NavigationController from "./email_navigation_controller.js"
import TodoController from "./todo_controller"
import SelectChangeController from "./select_change_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
import BillingCalculateController from "./billing_calculate_controller.js"
import SubscriptionController from "./subscription_controller"
import MoreOptionsController from "./more_options_controller.js"
import MoreOptionsFakturowniaController from "./more_options_fakturownia_controller.js"
import AppstoreAdditionalCheckboxesController from "./appstore_additional_checkboxes_controller.js"
import DatepickerController from "./datepicker_controller.js"
import IntumController from "./intum_controller.js"
import NestedFormController from "./nested_form_controller.js"
import AttachmentDownloaderController from "./attachment_downloader_controller.js"
import IframeController from "./iframe_controller.js"
import LexicalMarkdownController from "./lexical_markdown_controller.js"
import AutocompleteController from "./autocomplete_controller.js"
import AiButtonController from "./ai_button_controller.js"
import CallCenterTicketController from "./call_center_ticket_controller.js"
import RecurringFormController from "./recurring_form_controller.js"
import FieldsFormController from "./fields_form_controller.js"
import PdpTaxSplitController from "./pdp_tax_split_controller.js"
import DynamicCheckboxController from "./dynamic_checkbox_controller.js"
import WebhookTargetController from "./webhook_target_controller.js"
import AppstoreCategoryController from "./appstore_category_controller.js"
import TaskCalendarController from "./organize/task_calendar_controller.js"
import DashboardTabsController from "./dashboard_tabs_controller.js"
application.register("scroll", ScrollController)
application.register("chart-sprint", ChartSprintController)
application.register("pie-chart-sprint", PieChartSprintController)
application.register("hello", HelloController)
application.register("dropdown", DropdownController)
application.register("email", EmailController)
application.register("jodit", JoditController)
application.register("dropdown-photo", DropdownPhotoController)
application.register("toggle", ToggleController)
application.register("columns-reorder", ColumnsReorderController)
application.register("select", SelectController)
application.register("markdown-editor", MarkdownEditorController)
application.register("user-setting-fields", UserSettingFieldsController)
application.register("modal", ModalController)
application.register("sidebar", SidebarController)
application.register("attachment-view", AttachmentViewController)
application.register("modal-view", ModalViewController)
application.register("form-attachment", FormAttachmentController)
application.register("entry-view", EntryViewController)
application.register("header", HeaderController)
application.register("dropdown-search", DropdownSearchController)
application.register("multiselect", MultiselectController)
application.register("multiselect-search", MultiselectSearchController)
application.register("markdown-preview", MarkdownPreviewController)
application.register("crm-view", CrmViewController)
application.register("notification", NotificationController)
application.register("helplink", HelplinkController)
application.register("intum-dropzone", IntumDropzoneController)
application.register("copy-value", CopyValueController)
application.register("bulk-options", BulkOptionsController)
application.register("bulk-options-advanced", BulkOptionsAdvancedController)
application.register("comments", CommentsController)
application.register("cards", CardsController)
application.register("reload", ReloadController)
application.register("priority", PriorityController)
application.register("calendar", CalendarController)
application.register("tag-picker", TagPickerController)
application.register("forms", FormsController)
application.register("client-modal", ClientModalController)
application.register("country-prefix", CountryPrefixController)
application.register("employee-leave", EmployeeLeaveController)
application.register("after-change-update", AfterChangeUpdateController)
application.register("deal-tax", DealTaxController)
application.register("color-picker-simple", ColorPickerSimpleController)
application.register("dropdown-change-multiselect-fill", DropdownChangeMultiselectFillController)
application.register("drag-drop", DragDropConttroller)
application.register("kanban-drag", KanbanDragController)
application.register("draft", DraftController)
application.register("common-form", CommonFormController)
application.register("animated-dropdown", AnimatedDropdownController)
application.register("account-prefix", AccountPrefixController)
application.register("role-privileges", RolePrivilegesController)
application.register("copy-to-clipboard", CopyToClipboardController)
application.register("multi-dropdown", MultiDropdownController)
application.register("image-modal", ImageModalController)
application.register("intum-select", IntumSelectController)
application.register("greedy-dropdown", GreedyDropdownController)
application.register("select-load", SelectLoadController)
application.register("email-navigation", NavigationController)
application.register("todo", TodoController)
application.register("select-change", SelectChangeController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("billing-calculate", BillingCalculateController)
application.register("subscription", SubscriptionController)
application.register("more-options", MoreOptionsController)
application.register("more-options-fakturownia", MoreOptionsFakturowniaController)
application.register("appstore-additional-checkboxes", AppstoreAdditionalCheckboxesController)
application.register("datepicker", DatepickerController)
application.register("intum", IntumController)
application.register("nested-form", NestedFormController)
application.register("attachment-downloader", AttachmentDownloaderController)
application.register("iframe", IframeController)
application.register("lexical-markdown", LexicalMarkdownController)
application.register("autocomplete", AutocompleteController)
application.register("ai-button", AiButtonController)
application.register("call-center-ticket", CallCenterTicketController)
application.register("recurring-form", RecurringFormController)
application.register("fields-form", FieldsFormController)
application.register("pdp-tax-split", PdpTaxSplitController)
application.register("dynamic-checkbox", DynamicCheckboxController)
application.register("webhook-target", WebhookTargetController)
application.register("appstore-category", AppstoreCategoryController)
application.register("task-calendar", TaskCalendarController)
application.register("dashboard-tabs", DashboardTabsController)
